import { getDownloadURL } from "firebase/storage";
import { getFileRef } from "./documents/documents";

const getUploadedFileDownloadURL = async (path) => {
  const downloadURL = await getDownloadURL(getFileRef(path))
  return downloadURL
};

export default getUploadedFileDownloadURL;